<template>
  <div>
    <h1 class="sm:mb-8 mt-6 text-center text-2xl lg:text-3xl font-semibold">
      Search for Caterers
    </h1>
    <section class="flex flex-wrap justify-center">
      <div class="min-w-full sm:min-w-30 max-w-7xl flex-1 m-2">
        <!-- Search caterer form -->
        <div class="text-center">
          <input
            type="text"
            placeholder="Enter Delivery Zip Code (Exa: 90210)"
            class="w-full mr-2 h-16 sm:w-112 px-8 rounded-lg sm:rounded shadow-primary"
            v-model="location"
            @keyup.enter="search"
          />
          <div class="flex justify-center flex-col-reverse sm:flex-row mt-3">
            <LoadingButton
              class="btn btn-primary font-semibold rounded px-10 w-full sm:w-40 sm:flex-none"
              @click="search()"
              :loading="loading"
              :disabled="!canSubmit"
            >
              Search
            </LoadingButton>
          </div>
        </div>
        <!-- ### -->

        <OrderSearchCaterers
          v-if="!showNotFoundModal"
          :zip="zip"
          @select="onSubmitCaterer"
          @locationNotFound="showNotFoundModal = true"
        />
      </div>
    </section>

    <Modal v-if="showNotFoundModal" closeIcon="true" @close="tryAgain">
      <div slot="body">
        <div class="p-3 sm:p-5">
          <h1 class="font-semibold mb-6 text-center text-2xl">
            There are no caterers for this postal code in the BuildaBox.co
            directory at this time. Close this window and search nearby areas or
            select an option below to continue.
          </h1>

          <div class="text-center grid grid-cols-3 gap-3 items-start">
            <button
              class="btn btn-primary font-semibold rounded-lg px-12 mx-auto block h-full col-span-3 md:col-span-1"
              @click="submitWithoutCaterer"
            >
              Continue without a Caterer
            </button>
            <button
              class="btn btn-primary font-semibold rounded-lg px-12 mx-auto block h-full col-span-3 md:col-span-1"
              @click="$emit('goto', { type: 'invite_caterer' })"
            >
              Manually Invite a Caterer
            </button>
            <button
              class="btn btn-primary font-semibold rounded-lg px-12 mx-auto col-span-3 md:col-span-1"
              @click="$router.push('/caterer/my-business/details')"
            >
              Are you a caterer? Claim this territory now.
            </button>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal">
      <div slot="body">
        <div class="p-3 sm:p-5">
          <h1
            class="font-semibold mb-6 text-center text-2xl lg:text-3xl"
            v-if="isLocationVerified"
          >
            Success!!! BuildaBox.co provides catering services and delivery in
            your area.
          </h1>
          <h1
            class="font-semibold mb-6 text-center text-2xl lg:text-3xl"
            v-else
          >
            Unfortunately there are no caterers in the BuildaBox.co directory at
            this time
          </h1>

          <p class="mb-6 text-center">
            There are currently no caterers in our directory for this postal
            code. Move forward through the process and you can add caterers from
            outside of the directory at anytime.
          </p>
          <div class="text-center">
            <button
              class="btn btn-primary font-semibold rounded-lg px-12 mx-auto"
              @click="$emit('next', isLocationVerified)"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Api from "@/api";
import api_v1 from "@/api/api_v1.0";
import Spinner from "@/components/common/Spinner";
import Modal from "@/components/common/Modal";
import OrderSearchCaterers from "@/components/order/OrderSearchCaterers";
import LoadingButton from "@/components/common/LoadingButton";

export default {
  name: "WizardStepCatererLocation",
  components: { Spinner, Modal, OrderSearchCaterers, LoadingButton },
  data() {
    return {
      location: "",
      zip: null,
      loading: false,
      isLocationVerified: false,
      showModal: false,
      showNotFoundModal: false
    };
  },
  validations: {
    location: {
      required
    }
  },
  computed: {
    canSubmit() {
      const { location } = this.$v;
      return !location.$invalid;
    }
  },
  methods: {
    search() {
      this.loading = true;
      this.zip = this.location;

      this.$gtm.trackEvent({
        event: "segm_caterer_search",
        category: "Segmentation",
        action: "segmCatererSearch",
        label: "Search Caterer by Location",
        value: this.zip
      });

      this.loading = false;
    },

    async onSubmitCaterer(data) {
      this.isLocationVerified = true;

      // Updated location verified flag in the store.
      const order = this.$store.state.segmentationOrder;
      order.locationVerified = this.isLocationVerified;
      order.process = 3;
      this.$store.commit("setSegmentationOrder", order);

      await Api.updateOrderWith(order.uuid, { zipcode: data.zip, process: 3 });

      await api_v1.setOrderCaterer(order.uuid, data.id);

      this.$emit("next", this.isLocationVerified);
    },

    async submitWithoutCaterer(location) {
      const order = this.$store.state.segmentationOrder;
      order.locationVerified = false;
      this.$store.commit("setSegmentationOrder", order);

      await Api.updateOrderWith(order.uuid, { zipcode: location, process: 1 });
      this.$emit("next", false);
    },

    tryAgain() {
      this.showNotFoundModal = false;
      this.zip = "";
    }
  }
};
</script>
